import { render } from "./LearningGoalDetailsComponent.vue?vue&type=template&id=af2e6006&scoped=true"
import script from "./LearningGoalDetailsComponent.vue?vue&type=script&lang=js"
export * from "./LearningGoalDetailsComponent.vue?vue&type=script&lang=js"

import "./LearningGoalDetailsComponent.vue?vue&type=style&index=0&id=af2e6006&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af2e6006"]])

export default __exports__